import slice from "./onboardingSlice";

export default slice.reducer;
